import { render, staticRenderFns } from "./newMessage.vue?vue&type=template&id=059ed0c7&scoped=true"
import script from "./newMessage.vue?vue&type=script&lang=js"
export * from "./newMessage.vue?vue&type=script&lang=js"
import style0 from "./newMessage.vue?vue&type=style&index=0&id=059ed0c7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059ed0c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059ed0c7')) {
      api.createRecord('059ed0c7', component.options)
    } else {
      api.reload('059ed0c7', component.options)
    }
    module.hot.accept("./newMessage.vue?vue&type=template&id=059ed0c7&scoped=true", function () {
      api.rerender('059ed0c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplierManagement/systemMessages/component/newMessage.vue"
export default component.exports